import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FiMapPin, FiClock, FiCalendar, FiArrowLeft, FiUsers, FiDollarSign, FiClock as FiDuration } from 'react-icons/fi';
import {
  EventDetailContainer,
  EventHero,
  HeroImage,
  EventInfo,
  EventTitle,
  EventMeta,
  EventCategory,
  ContentSection,
  MainContent,
  Sidebar,
  DetailItem,
  RegisterButton,
  BackButton
} from '../styles/EventDetailStyle';
import { events } from '../data/events';
import PageLayout from '../components/PageLayout';
import axios from 'axios';
import Footer from '../components/Footer';

function EventDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);

  useEffect(() => {
    // fetch events data 
    axios.get('http://localhost:8000/events')
      .then(response => {
        setEvents(response.data);
      })
      .catch(error => {
        console.error('Error fetching events:', error);
      });
  }, []);

  const event = events.find(e => e._id === id);

  if (!event) {
    return (
      <PageLayout>
        <EventDetailContainer>
          <h1>Event not found</h1>
          <button onClick={() => navigate('/events')}>Back to Events</button>
        </EventDetailContainer>
      </PageLayout>
    );
  }

  const formatDate = (dateString) => {
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <PageLayout>
      <EventDetailContainer>
        <BackButton onClick={() => navigate('/events')}>
          <FiArrowLeft />
        </BackButton>
        
        <EventHero>
          <HeroImage src={event.image} alt={event.title} />
          <EventInfo>
            <EventCategory>{event.category}</EventCategory>
            <EventTitle>{event.title}</EventTitle>
            <EventMeta>
              <div>
                <FiCalendar />
                {formatDate(event.date)}
              </div>
              <div>
                <FiClock />
                {event.time}
              </div>
              <div>
                <FiMapPin />
                {event.location}
              </div>
            </EventMeta>
          </EventInfo>
        </EventHero>

        <ContentSection>
          <MainContent>
            <h2>About the Event</h2>
            <p>{event.description}</p>
            
            <h2>What to Expect</h2>
            <p>Join us for this exceptional event where creativity meets innovation. Whether you're a seasoned professional or an enthusiastic beginner, this event offers something for everyone. Network with industry leaders, gain valuable insights, and be part of our growing creative community.</p>
            
            {event.details && (
              <>
                <h2>Featured Speakers</h2>
                <p>Learn from industry experts and thought leaders who will share their knowledge and experiences. Our speakers bring diverse perspectives and deep expertise to create an enriching experience.</p>
              </>
            )}
          </MainContent>

          <Sidebar>
            <DetailItem>
              <h3>Event Details</h3>
            </DetailItem>

            <RegisterButton onClick={() => window.alert('Registration feature coming soon!')}>
              Register Now
            </RegisterButton>
          </Sidebar>
        </ContentSection>
        <Footer />
      </EventDetailContainer>
    </PageLayout>
  );
}

export default EventDetail; 